<div class="row">
  <div class="col-1">
    <app-back-button></app-back-button>
  </div>
  <div class="col">
    <h2 class="h2-responsive text-center">New Range</h2>
  </div>
</div>
<div class="row">
  <div class="col">
    <div class="card card-cascade narrower">
        <div class="view gradient-card-header primary-gradient white-text">
            <h3 class='h3-responsive text-center'>{{range.name}}</h3>
        </div>
        <div class="card-body">
        <form>
          <div class="form-group">
            <label for="name">Name:</label>
            <input class="form-control" type="text" name="name" id="name" [(ngModel)]="range.name" />
          </div>
          <div class="form-group">
            <label for="displayName">Display Name:</label>
            <input class="form-control" type="text" name="displayName" id="displayName" [(ngModel)]="range.displayName" />
          </div>
          <div class="form-group">
                <label for="rangeStart">Range Start:</label>
            <input class="form-control" type="number" name="rangeStart" id="rangeStart" [(ngModel)]="range.rangeStart" />
          </div>
          <div class="form-group">
                <label for="rangeEnd">Range End:</label>
            <input class="form-control" type="number" name="rangeEnd" id="rangeEnd" [(ngModel)]="range.rangeEnd" />
          </div>
          <div class="form-group">
            <label for="therapistContent">Therapist Content:</label>
            <textarea class="form-control" rows="5" name="therapistContent" [(ngModel)]="range.therapistContent" id="therapistContent"></textarea>
          </div>
          <div class="form-group">
            <label for="clientContent">Client Content:</label>
            <textarea class="form-control" rows="5" name="clientContent" [(ngModel)]="range.clientContent" id="clientContent"></textarea>
          </div>
          <div class="form-group">
            <label for="mediaURL">Media URL:</label>
            <input class="form-control" type="text" name="mediaURL" id="mediaURL" [(ngModel)]="range.mediaURL" />
          </div>
          <div class="form-group">
            <label for="assignmentURL">Assignment URL:</label>
            <input class="form-control" type="text" name="assignmentURL" id="assignmentURL" [(ngModel)]="range.assignmentURL" />
          </div>
        </form>
        <input type="button" (click)="save()" class="btn btn-primary" value="Save" />
        <input type="button" (click)="saveAndCreateNew()" class="btn btn-primary" value="Save and Create New" />
        <!--<pre>
          {{range|json}}
        </pre>-->
      </div>
    </div>
  </div>
</div>


// WEBPACK FOOTER //
// ./src/app/admin/scale-range-new/scale-range-new.component.html